import { render, staticRenderFns } from "./StateComponent.vue?vue&type=template&id=2706039c&lang=pug"
import script from "./StateComponent.vue?vue&type=script&lang=js"
export * from "./StateComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2706039c')) {
      api.createRecord('2706039c', component.options)
    } else {
      api.reload('2706039c', component.options)
    }
    module.hot.accept("./StateComponent.vue?vue&type=template&id=2706039c&lang=pug", function () {
      api.rerender('2706039c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StateComponent.vue"
export default component.exports